import './PlayerInfo.css';
import PlayerInfo from './PlayerInfo';
export default PlayerInfo;



// WEBPACK FOOTER //
// ./src/components/Game/components/PlayerInfo/index.js